import ReadOnlyField from "../../../../../Forms/ReadOnly/ReadOnlyField";

const ConfirmedInfoSection = ({ form }) => {
  if (!form.confirmedByName) return null;

  return (
    <div className="grid grid-cols-2 gap-4 mt-4">
      <ReadOnlyField label="Confirmado Por" value={form.confirmedByName} />
      <ReadOnlyField
        label="Fecha Confirmación"
        value={`${form.confirmedDate} ${form.confirmedTime}`}
      />
    </div>
  );
};

export default ConfirmedInfoSection;
